<template>
  <div class="wrap1">
    <h2 class="common-title">
      <i class="el-icon-arrow-left icon" @click="handlerBack"></i>
      {{ $t('871') }}
    </h2>
    <div class="wrap1-box record">
      <p class="common-info">
        <span>{{ $t('payroll_management_31') }}：{{ salaryData.staff_name }}</span>
        <span>{{ $t('27') }}：{{ salaryData.department_name }}</span>
        <span>{{ $t('1516') }}：{{ salaryData.hire_date }}</span>
      </p>
      <div class="record-select">
        <div class="record-left">
          <div class="year">
            <span>{{ $t('1591') }}</span>
            <el-date-picker
              class="picker"
              v-model="year"
              value-format="yyyy"
              size="small"
              :clearable="false"
              type="year"
              @change="handleYear"
            >
            </el-date-picker>
            <i class="record-icon el-icon-arrow-down"></i>
          </div>
          <el-radio-group v-model="settlement_type" @change="handleYear" size="small">
            <el-radio-button
              v-for="item in sysInfo.settlement_type"
              :key="item.settlement_type"
              :label="item.settlement_type"
              >{{ item.name }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="record-center"></div>
        <div class="record-right">
          {{ $t('payroll_managemen_41') }}：
          <span class="one"> <i></i> {{ $t('146') }} </span>
          <span class="two"> <i></i> {{ $t('147') }} </span>
          <span class="three"> <i></i> {{ $t('payroll_management_60') }} </span>
        </div>
      </div>
      <el-table :data="historyList" style="width: 100%">
        <el-table-column prop="name" :label="$t('1345')" fixed="left" :width="!columnsList.length ? 'auto' : '150'">
        </el-table-column>
        <el-table-column prop="name" :label="$t('new_operation_time')" align="center">
          <el-table-column
            v-for="item in columnsList"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="144"
          >
            <template slot-scope="scope">
              <template v-if="!!(scope.row[item.prop] && scope.row[item.prop].val)">
                <el-button
                  v-if="handleData(scope.row[item.prop].val)"
                  type="text"
                  @click="onClick(scope.row[item.prop].val)"
                  >{{ $t('64') }}</el-button
                >
                <span
                  v-else
                  :class="{
                    add: scope.row[item.prop].flag === 1,
                    reduce: scope.row[item.prop].flag === -1
                  }"
                >
                  {{ scope.row[item.prop].val }}
                </span>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getStaffUpdateSalaryDetailList, getStaffUpdateSalaryDetailType } from '@/api/payroll'

export default {
  components: {},
  props: {
    staffId: String,
    subProjectId: String,
    type: String
  },
  data() {
    return {
      historyList: [],
      columnsList: [],
      salaryData: {},
      sysInfo: {
        settlement_type: []
      },
      staff_id: this.$route.params.staff_id,
      settlement_type: '',
      year: new Date().getFullYear().toString()
    }
  },
  created() {
    this.getSysInfoFn()
  },
  methods: {
    getSysInfoFn() {
      // 员工调薪详情_type
      getStaffUpdateSalaryDetailType({ staff_info_id: this.staff_id, year: this.year }).then(res => {
        if (res && res.code === 1) {
          this.sysInfo.settlement_type = res.data
          this.settlement_type = res.data.length ? res.data[0].settlement_type : this.$route.query.type
        }
        this.init()
      })
    },
    handlerBack() {
      this.$router.go(-1)
    },
    handleData(val) {
      if (typeof val === 'string') {
        return val.indexOf('http') !== -1
      }
    },
    async init() {
      // 调薪纪录
      const res = await getStaffUpdateSalaryDetailList({
        staff_info_id: this.staff_id,
        settlement_type: this.settlement_type,
        year: this.year
      })
      try {
        if (res && res.code === 1) {
          this.salaryData = res.data.staff_info
          this.columnsList = []
          this.historyList = []
          if (!res.data.columns.length) return
          res.data.columns.forEach(item => {
            const val = res.data.column_datetime[item]
            this.columnsList.push({
              label: `${val.date} ${val.time}`,
              prop: item
            })
          })
          this.historyList = res.data.item_val
        }
      } catch {}
    },
    handleYear() {
      this.init()
    },
    onClick(url) {
      window.open(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.record {
  padding-bottom: 20px;
  &-select {
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &-center {
    margin-bottom: 12px;
    flex: 1;
  }
  &-left {
    margin-bottom: 12px;
    margin-right: 24px;
    display: flex;
    .year {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      position: relative;
      margin-right: 24px;

      span {
        color: rgba(0, 0, 0, 0.45);
        position: absolute;
        left: 12px;
        top: 8px;
        z-index: 2;
      }
      .record-icon {
        position: absolute;
        right: 12px;
        top: 8px;
        z-index: 2;
      }
      /deep/.picker {
        max-width: 165px;
        font-size: 14px;
        .el-input__inner {
          padding-left: 100px;
          padding-right: 0px;
        }
        .el-input__prefix {
          display: none;
        }
      }
    }
  }
  &-right {
    margin-bottom: 12px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    word-break: break-word;
    .one {
      i {
        background: #52c41a;
      }
    }
    .two {
      margin: 0 24px;
      i {
        background: #ff4d4f;
      }
    }
    .three {
      i {
        background: rgba(0, 0, 0, 0.45);
      }
    }
    i {
      border-radius: 50%;
      display: inline-block;
      width: 8px;
      height: 8px;
    }
  }
  /deep/ .el-radio-group {
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #fff;
      color: #5D51DA;
    }
  }
}
.add {
  color: #52c41a;
}
.reduce {
  color: #ff4d4f;
}
.common-info {
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.icon {
  margin-right: 24px;
  cursor: pointer;
}
</style>
